import ReactGA from 'react-ga4';

const initializeAnalytics = () => {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    
  ReactGA.initialize(measurementId); // Replace 'YOUR_MEASUREMENT_ID' with the actual measurement ID
};

export default initializeAnalytics;
